// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c85a8f1f","239":"ca2900f8","455":"bb026fa2"}[chunkId] + ".chunk.js";
};